import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa"; 

function Footer() {
  return (
    <>
    <footer>
      <div class="footer-container">
        <div class="footer-section">
          <h4>Swingwings NG LTD</h4>
          <p>
           Swingwings NG LTD supplies solar street lights and distributes foreign children’s books in bulk, offering curated collections and library solutions that support literacy and learning.
          </p>
        </div>
        <div class="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="/termsofservice">Terms of service</a>
            </li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>Follow Us</h4>
          <div class="social-links">
            <a href="#">
              <FaFacebook size={30} />
            </a>
            <a href="#">
              <FaTwitter size={30} />
            </a>
            <a href="#">
              <FaInstagram size={30} />
            </a>
            <a href="#">
              <FaLinkedin size={30} />
            </a>
          </div>
        </div>
        <div class="footer-section">
          <h4>Subscribe</h4>
          <form action="/subscribe" method="POST">
            <input type="email" placeholder="Enter your email" required />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2025 Swingwings NG LTD. All Rights Reserved.</p>
      </div>
    </footer>
    </>
  );
}

export default Footer;
